import validator from "validator";

// The server's own rules (INC-1955 §2). Checking them here is not belt and braces: the
// attachment is uploaded with the form, so a reason that is one character short costs a
// full multipart round trip before the 400 comes back.
const NAME_MIN = 2;
const NAME_MAX = 100;
const REASON_MIN = 10;
const REASON_MAX = 1000;

function validateDeleteAccount(data) {
  const errors = {};
  const name = data.requestedByName.trim();
  const reason = data.reason.trim();

  if (validator.isEmpty(name))
    errors.requestedByName = "Please enter the requester's name.";
  else if (name.length < NAME_MIN || name.length > NAME_MAX)
    errors.requestedByName = `The name must be ${NAME_MIN}-${NAME_MAX} characters.`;

  if (validator.isEmpty(data.requestedByEmail.trim()))
    errors.requestedByEmail = "Please enter the requester's email.";
  else if (!validator.isEmail(data.requestedByEmail.trim()))
    errors.requestedByEmail = "Please enter a valid email.";

  // Collected because every Figma modal shows the picker, and deliberately not sent: the
  // ticket makes Requested At system-generated and the API rejects a supplied value.
  if (!data.requestedAt)
    errors.requestedAt = "Please select the request date & time.";
  else if (data.requestedAt > new Date())
    errors.requestedAt = "Request date & time can't be in the future.";

  if (validator.isEmpty(reason))
    errors.reason = "Please enter the deletion reason.";
  else if (reason.length < REASON_MIN)
    errors.reason = `Please give at least ${REASON_MIN} characters of reason.`;
  else if (reason.length > REASON_MAX)
    errors.reason = `The reason must be ${REASON_MAX} characters or fewer.`;

  if (!data.attachment) errors.attachment = "Please upload an attachment.";

  return { errors, isValid: Object.keys(errors).length <= 0 };
}

export default validateDeleteAccount;
